module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#business",
      toString: function () {
        return this.url;
      }
    }